import { getGoogleFontsUrl } from '../constants/builder-fonts';

export const MATERIAL_THEME_LINK_ID = 'fittara-material-theme';
export const MATERIAL_THEME_HREF = 'assets/themes/indigo-pink.css';
export const LANDING_BUILDER_FONT_LINK_ID = 'landing-builder-font-catalog';

const MATERIAL_ROUTE_PREFIXES = [
  '/admin-dashboard',
  '/add-material',
  '/cloth-editor',
  '/landing-builder',
  '/page-builder',
  '/cart',
  '/home-trial',
  '/customer-order',
];

/**
 * The Material theme is not part of the public storefront entry. Load it only
 * for routes that render Material controls, or for ShopOwner sessions whose
 * lazily loaded assistant uses Material overlays.
 */
export function routeNeedsMaterialTheme(
  url: string,
  role: string | null | undefined,
): boolean {
  if (/ShopOwner/i.test(role || '')) {
    return true;
  }

  const path = (url || '/').split(/[?#]/, 1)[0].toLowerCase();
  return MATERIAL_ROUTE_PREFIXES.some(prefix =>
    path === prefix || path.startsWith(`${prefix}/`),
  );
}

/** Insert the admin/control-flow theme once; subsequent calls are idempotent. */
export function ensureMaterialTheme(documentRef: Document = document): HTMLLinkElement {
  const existing = documentRef.getElementById(
    MATERIAL_THEME_LINK_ID,
  ) as HTMLLinkElement | null;
  if (existing) {
    return existing;
  }

  const link = documentRef.createElement('link');
  link.id = MATERIAL_THEME_LINK_ID;
  link.rel = 'stylesheet';
  link.href = MATERIAL_THEME_HREF;
  documentRef.head.appendChild(link);
  return link;
}

/**
 * The legacy landing editor still needs its complete font picker, but the public
 * storefront must not pay for that catalog. This route-only link preserves the
 * editor preview without returning the catalog to index.html.
 */
export function ensureLandingBuilderFontCatalog(
  documentRef: Document = document,
): HTMLLinkElement {
  const existing = documentRef.getElementById(
    LANDING_BUILDER_FONT_LINK_ID,
  ) as HTMLLinkElement | null;
  if (existing) {
    return existing;
  }

  const link = documentRef.createElement('link');
  link.id = LANDING_BUILDER_FONT_LINK_ID;
  link.rel = 'stylesheet';
  link.href = getGoogleFontsUrl();
  documentRef.head.appendChild(link);
  return link;
}
